<template>
  <div class="m-pc-content" v-html="content"></div>
</template>
<script>
import { $subscriber } from "fire-wind-water";
export default {
  name: "Content",
  data() {
    return {
      content: ""
    };
  },
  created() {
    $subscriber.subscribe("article-info", info => {
      if (info) {
        this.content = info.content;
      }
    });
  },
  components: {}
};
</script>
